<template>
    <div
        id="OpportunityPageButtons"
        class="sm:space-y-0"
        :class="{
            'flex flex-col items-center justify-between sm:flex-row': isFlexbox,
            'gap-3 sm:grid sm:grid-cols-12 ': !isFlexbox,
            'space-y-3': !fixedOnMobile,
            'opportunity-buttons--fixed fixed bottom-0 left-0 z-10 flex w-full bg-white dark:bg-surface-card p-4 shadow-navbar sm:relative sm:bg-transparent sm:p-0 sm:shadow-none':
                fixedOnMobile
        }"
    >
        <div class="flex w-full sm:col-span-3">
            <slot />
        </div>
    
        <div class="ml-auto w-fit sm:col-span-9 sm:w-auto">
            <div class="flex justify-end">
                <CFavouriteButton
                    :id="id"
                    :hide-text-on-mobile="fixedOnMobile"
                    :lang="lang"
                    :org-name="orgName"
                    :org-type="orgType"
                    :preview="preview"
                    :title="title"
                    :type="type"
                />

                <CShareButton
                    v-if="!disableSharing"
                    :id="id"
                    :hide-text-on-mobile="fixedOnMobile"
                    :lang="lang"
                    :preview="preview"
                    :title="title"
                    :type="type"
                />

                <CReportButton
                    v-if="canObjectBeReported()"
                    :hide-text-on-mobile="fixedOnMobile"
                    :lang="lang"
                    :preview="preview"
                    :title="title"
                    :type="type"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { UserId } from '#shared/types/ids'
import type { JobId } from '#shared/types/Job'
import type { OrgType } from '#shared/types/Org'
import type { ProjectId } from '#shared/types/Project'
import type { SkillId } from '#shared/types/Skill'

interface Props {
    type: string
    id?: SkillId | UserId | JobId | ProjectId
    title: string
    lang?: string
    orgName?: string
    orgType?: OrgType
    preview?: boolean
    disableSharing?: boolean
    fixedOnMobile?: boolean
    isFlexbox?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    id: undefined,
    lang: 'sk',
    orgName: '',
    orgType: undefined,
    preview: false,
    disableSharing: false,
    fixedOnMobile: false,
    isFlexbox: false
})

function canObjectBeReported() {
    return ['org', 'skill', 'project', 'job', 'mentor', 'volunteer', 'community', 'talentbase'].includes(
        props.type
    )
}
</script>
